import { captionStrong } from '../../styles/commonStyles';
import WrappedText from '../wrappedText';
import ExistingTagsItemBase from './existingTagsItemBase';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { createStyles, makeStyles } from '@mui/styles';
import clsx from 'clsx';
import { Colors, Icons } from 'copyright-clearance-center-common-ui';

export interface IExistingTagsItemProps {
	tag: string;
	new?: boolean;
	selected?: boolean;
	label: string;
	onSelect?: (tag: string) => void;
	onRemove?: (tag: string) => void;
	onUpdate?: (tag: string) => void;
	editable?: boolean;
}

const TagActionsSpacing = 1;

const useStyles = makeStyles(() =>
	createStyles({
		errorIconBtn: {
			'&:not([disabled])': {
				color: `${Colors.error500} !important`,
				'&:hover': {
					backgroundColor: `${Colors.error100} !important`
				},
				'&:active': {
					backgroundColor: `${Colors.error300} !important`
				}
			}
		}
	})
);

const ExistingTagsItem: React.FunctionComponent<IExistingTagsItemProps> = props => {
	const classes = useStyles();

	const renderTagEditActions = () => {
		const onUpdateClickHandler = props.onUpdate ? () => props.onUpdate(props.tag) : null;
		const onRemoveClickHandler = props.onRemove ? () => props.onRemove(props.tag) : null;

		return (
			<Stack direction="row" spacing={TagActionsSpacing}>
				<button
					className={clsx('rup-icon-btn rup-icon-btn--sm')}
					data-test-id="rename-tag-btn"
					type="button"
					disabled={!onUpdateClickHandler}
					onClick={onUpdateClickHandler}
				>
					<span className="rup-icon" dangerouslySetInnerHTML={{ __html: Icons.EditIcon }} />
				</button>
				<button
					className={clsx('rup-icon-btn rup-icon-btn--sm', classes.errorIconBtn)}
					data-test-id="delete-tag-btn"
					type="button"
					disabled={!onRemoveClickHandler}
					onClick={onRemoveClickHandler}
				>
					<span className="rup-icon" dangerouslySetInnerHTML={{ __html: Icons.RemoveIcon }} />
				</button>
			</Stack>
		);
	};

	return (
		<ExistingTagsItemBase
			sx={{
				':hover': { backgroundColor: Colors.neutral100 },
				backgroundColor: props.new ? Colors.primary50 : 'inherit',
				overflow: 'hidden'
			}}
			data-test-id="available-tag-container"
		>
			<Box sx={{ ...captionStrong, lineHeight: '1.5rem' }} overflow="hidden" data-test-id="available-tag-text">
				<WrappedText text={props.label} />
			</Box>
			{!props.editable && (
				<Stack direction="row">
					{props.onSelect && (
						<button
							className="rup-btn rup-btn--sm rup-btn--text"
							type="button"
							onClick={() => {
								if (!props.selected) {
									props.onSelect(props.tag);
								}
							}}
							disabled={props.selected}
							data-test-id="select-btn"
						>
							{localize('Select')}
						</button>
					)}
				</Stack>
			)}
			{props.editable && renderTagEditActions()}
		</ExistingTagsItemBase>
	);
};

export default ExistingTagsItem;
